var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.dialog, "max-width": "700" },
      on: {
        "click:outside": _vm.close,
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.close.apply(null, arguments)
        },
      },
    },
    [
      _vm.payslip
        ? _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c("span", { staticClass: "headline" }, [
                    _vm._v("Historial del recibo"),
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    { attrs: { icon: "" }, on: { click: _vm.close } },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  _vm.loading
                    ? _c(
                        "div",
                        { staticClass: "text-center py-10" },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", color: "primary" },
                          }),
                        ],
                        1
                      )
                    : _c(
                        "v-timeline",
                        { attrs: { dense: "" } },
                        _vm._l(_vm.list, function (event) {
                          return _c(
                            "v-timeline-item",
                            {
                              key: event.id,
                              attrs: {
                                small: "",
                                color:
                                  event.event == "voided" ? "red" : "primary",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex justify-space-between" },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.eventName(event.event))),
                                  ]),
                                  _c("span", { staticClass: "grey--text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatDateTime(event.creation_date)
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _c("div", [_vm._v(_vm._s(event.user || "-"))]),
                              event.event == "signed" && event.data
                                ? _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          event.data.conformity == "disagree"
                                            ? "Disconforme"
                                            : "Conforme"
                                        ) +
                                        " · Código " +
                                        _vm._s(event.data.verification_code) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                              event.data && event.data.reason
                                ? _c("div", [
                                    _vm._v(
                                      "Motivo: " + _vm._s(event.data.reason)
                                    ),
                                  ])
                                : _vm._e(),
                              event.event == "ai_read"
                                ? _c("div", [
                                    _vm._v(
                                      " CUIL: " +
                                        _vm._s(
                                          event.data.cuil || "no encontrado"
                                        )
                                    ),
                                    event.data.employee_name
                                      ? _c("span", [
                                          _vm._v(
                                            " · " +
                                              _vm._s(event.data.employee_name)
                                          ),
                                        ])
                                      : _vm._e(),
                                    event.data.employee_number
                                      ? _c("span", [
                                          _vm._v(
                                            " · Legajo " +
                                              _vm._s(event.data.employee_number)
                                          ),
                                        ])
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                              event.data && event.data.replaces_id
                                ? _c("div", [
                                    _vm._v(
                                      "Reemplaza al recibo #" +
                                        _vm._s(event.data.replaces_id)
                                    ),
                                  ])
                                : _vm._e(),
                              event.data && event.data.batch_id
                                ? _c("div", [
                                    _vm._v(
                                      " Lote #" +
                                        _vm._s(event.data.batch_id) +
                                        ", página " +
                                        _vm._s(event.data.page_from)
                                    ),
                                    event.data.page_to != event.data.page_from
                                      ? _c("span", [
                                          _vm._v(
                                            "-" + _vm._s(event.data.page_to)
                                          ),
                                        ])
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        }),
                        1
                      ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }